import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LoginForm from "../components/LoginForm";

const LoginPage = () => (
  <Container className="mt-5">
    <Row className="justify-content-center">
      <Col xs={12} md={6}>
        <h2 className="text-center mb-4">Login</h2>
        <LoginForm />
      </Col>
    </Row>
  </Container>
);

export default LoginPage;
